import type { OrganisationId } from "../types/organisation.js";

/**
 * Whether starting an involvement for a party under this organisation deserves
 * a warning. `null` is a guest, a user with no organisation behind them, who is
 * distant, and that is the honest answer rather than an edge case: nothing
 * connects them to this person's care but the involvement being started.
 *
 * It warns and never blocks. An emergency where the right party is a stranger
 * is exactly when a refusal would be wrong, and an involvement started anyway
 * is recorded with an author like any other.
 */
export const isOrganisationDistantFromPerson = ({
  organisationId,
  near,
}: {
  organisationId: OrganisationId | null;
  near: readonly OrganisationId[];
}): boolean => organisationId === null || !near.includes(organisationId);
